module.exports = __webpack_public_path__ + "static/media/15_2.a5bb8117.jpg";